<template>
  <div>
    <Modal v-model="modal1" width="1000" :title="$t('key1006100')">
      <template v-if="step===1">
        <p class="mb5"><span class="red-dot"></span>{{ $t('key1006103') }}</p>
        <Table :columns="columns1" :data="goodsList" @on-selection-change="selectionChange"></Table>
      </template>
      <template v-else-if="step===2">
        <Table :columns="columns2" :data="checkData"></Table>
      </template>
      <template #footer>
        <Button @click="modal1 = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="confirm" :loading="btnLoading">{{ step === 1 ? $t('key1002560') : $t('key1006102') }}</Button>
      </template>
    </Modal>
    <!--添加商品弹窗-->
    <addCommonProductModal
      ref="addCommonProduct"
      :apiUrl="apiUrl"
      :customStyle="true"
      :showOptionsBtn="false"
      systemType="distributor"
      :distributorShowFieldKeyList="['options', 'goodsInfo','myInventory', 'supplierAvailableNumber', 'ymsAvailableNumber', 'suggestPrice', 'weight', 'length', 'status']"
      @selectGoodsList="selectProduct">
    </addCommonProductModal>
    <!--条码缺失提示弹窗-->
    <barcodePromptModal ref="barcodePrompt" :orderType="platformOrderDetails.orderType"></barcodePromptModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import addCommonProductModal from "@/components/common/addCommonProductModal";
import api from '@/api/';
import barcodePromptModal from "@/views/distributor/components/orderManage/barcodePromptModal";

export default {
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      step: 1,
      modal1: false,
      btnLoading: false,
      columns1: [],
      columns2: [],
      goodsList: [],
      goodsListClone: [],
      checkData: [],
      addProductIndex: 0,
      ymsPlatformOrderId: '',
      apiUrl: api.post_ymsDistributorProductInfo_queryYmsProductGoods,
      platformOrderDetails: {},
      platformIdList: ['ebay', 'shopee', 'walmart'], // 当订单为shopee、ebay、walmart时，需展示对应交易号
    };
  },
  methods: {
    confirm() {
      let v = this;
      // 下一步
      if (v.step === 1) {
        let _valid = false;
        v.goodsListClone.forEach(i => {
          if (i.checked && Number(i.changeQuantity) === 0) {
            _valid = true;
          }
        });

        if (v.goodsListClone.some(i => i.changeQuantity > i.quantity)) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006095'));
          return;
        }

        if (v.checkData.length === 0) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006096'));
          return;
        }
        if (_valid) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006097'));
          return;
        }
        v.step = 2;
      }
      // 确认更换
      else if (v.step === 2) {
        let _valid = false;
        v.checkData.forEach(i => {
          if (!i._replaceGoods) {
            _valid = true;
          }
        });
        if (_valid) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006098'));
          return;
        }
        let _goodsList = JSON.parse(JSON.stringify(v.goodsListClone));
        let _checkData = JSON.parse(JSON.stringify(v.checkData));
        _goodsList.forEach(i => {
          i._quantity = i.quantity - i.changeQuantity;
        });
        _goodsList = _goodsList.filter(i => i._quantity > 0);
        _checkData.forEach(i => {
          v.goodsListClone.forEach(j => {
            if (i.ymsProductGoodsId === j.ymsProductGoodsId && i.platformOrderTransactionId === j.platformOrderTransactionId) {
              i._quantity = j.changeQuantity;
            }
          });
        });

        _goodsList.forEach(i => {
          _checkData.forEach(j => {
            if (i.ymsSku === j._replaceGoods.ymsSku && i.platformOrderTransactionId === j.platformOrderTransactionId) {
              i._quantity = Number(i._quantity) + Number(j._quantity);
              j._hasSku = true;
            }
          });
        });

        let goods = [..._goodsList.map(i => {
          return {
            platformOrderTransactionId: i.platformOrderTransactionId,
            ymsSku: i.ymsSku,
            originalSku: i.ymsSku,
            ymsProductGoodsId: i.ymsProductGoodsId,
            quantity: Number(i._quantity)
          };
        }), ..._checkData.filter(i => {
          return !i._hasSku;
        }).map(i => {
          return {
            platformOrderTransactionId: i.platformOrderTransactionId,
            ymsSku: i._replaceGoods.ymsSku,
            originalSku: i.ymsSku,
            ymsProductGoodsId: i._replaceGoods.ymsProductGoodsId,
            quantity: Number(i._quantity)
          };
        })];

        let params = {
          ymsPlatformOrderId: v.ymsPlatformOrderId,
          packageGoodsList: goods // 所有货品 包含替换商品和原商品
        };

        function handleData() {
          v.btnLoading = true;
          v.axios.post(api.post_ymsPlatformOrder_replacePackageGoods, params).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
              v.btnLoading = false;
              v.modal1 = false;
              v.$emit('success');
            }
          });
        }

        // Temu平台订单更换商品时，先要校验当前商品中是否已经上传条码标签
        if (v.platformOrderDetails.platformId === 'temu') {
          v.verificationUnlabeledGoods(_checkData).then(() => {
            handleData();
          });
        } else {
          handleData();
        }
      }
    },
    // 校验无标签商品
    verificationUnlabeledGoods(tableData) {
      let v = this;
      return new Promise(resolve => {
        let ymsProductGoodsIds = tableData.map((item) => {
          return item._replaceGoods.ymsProductGoodsId;
        });
        let query = {
          ymsPlatformAccountId: v.platformOrderDetails.ymsPlatformAccountId,
          ymsProductGoodsIds: ymsProductGoodsIds,
          labelType: v.platformOrderDetails.orderType
        };
        v.axios.post(api.post_ymsThirdPlatformProductLabel_api_checkNotLabel, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data && data.length > 0) {
              v.$refs['barcodePrompt'].barcodePromptData(data);
            } else {
              resolve(true);
            }
          }
        });
      });
    },
    openAddProduct({index}) {
      this.addProductIndex = index;
      this.$refs['addCommonProduct'].matchingGoodsType = 'single';
      this.$refs['addCommonProduct'].initFun();
    },
    selectProduct(data) {
      let v = this;
      if (data.ymsSku === v.checkData[v.addProductIndex].ymsSku) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006094'));
        return;
      }
      this.$set(v.checkData[v.addProductIndex], '_replaceGoods', data);
    },
    // 初始化数据
    open(ymsOrderInfoList, platformOrderDetails) {
      let v = this;
      v.step = 1;
      v.ymsPlatformOrderId = platformOrderDetails.ymsPlatformOrderId;
      let ymsPlatformOrderShippingDetails = platformOrderDetails.ymsPlatformOrderShippingDetails || [];
      v.goodsListClone = [];
      v.platformOrderDetails = platformOrderDetails;
      if (ymsPlatformOrderShippingDetails.length > 0) {
        let businessIds = [];
        let newList = [];
        ymsPlatformOrderShippingDetails.map((item) => {
          if (item.businessId) {
            item.ymsProductGoodsId = item.businessId;
            businessIds.push(item.businessId);
          }
        });
        if (businessIds.length > 0) {
          (async () => {
            newList = await v.getProductInfoByIds(businessIds, ymsPlatformOrderShippingDetails);
            if (newList.length > 0) {
              newList.map((item) => {
                item.checked = false;
                item.changeQuantity = 0;
                item._replaceGoods = null;
                if (item._productInfo) {
                  item.title = item._productInfo._spuInfo.name;
                  item.ymsSku = item._productInfo.ymsSku;
                  let skuImgPath = item._productInfo.primaryImage;
                  let spuImgPath = item._productInfo._spuInfo.primaryImage;
                  item.pictureUrl = skuImgPath ? skuImgPath : spuImgPath;
                  let productGoodsSpecificationList = item._productInfo.productGoodsSpecificationList || [];
                  item.variations = productGoodsSpecificationList.map(i => i.name + '：' + i.value).join('、');
                }
              });
              v.goodsList = newList;
              v.goodsListClone = JSON.parse(JSON.stringify(this.goodsList));
              v.modal1 = true;
            }
          })();
        }
      } else {
        v.goodsList = [];
        v._goodsList = [];
      }
    },
    selectionChange(data) {
      let v = this;
      v.goodsListClone.forEach((j, index) => {
        if (v.platformIdList.includes(v.platformOrderDetails.platformId)) {
          let _check = data.some(i => i.platformOrderTransactionId === j.platformOrderTransactionId);
          v.$set(v.goodsListClone[index], 'checked', _check);
          if (!_check) {
            v.$set(v.goodsListClone[index], 'changeQuantity', 0);
          }
        } else {
          let _check = data.some(i => i.ymsSku === j.ymsSku);
          v.$set(v.goodsListClone[index], 'checked', _check);
        }
      });
      v.checkData = data;
    },
    // 处理列表字段
    handleColumns(val) {
      let v = this;
      v.optionBtnWidth = [];
      let columns1 = [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006050'),
          key: 'platformOrderTransactionId'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          minWidth: 240,
          render(h, params) {
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, 'pictureUrl'),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.title),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.ymsSku)
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, params.row.variations),
                ])
              ])]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803'),
          key: 'quantity'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006090'),
          key: 'number',
          render(h, params) {
            return h('div', [
              h('Input', {
                props: {
                  disabled: !v.goodsListClone[params.index].checked,
                  value: v.goodsListClone[params.index].changeQuantity
                },
                class: v.goodsListClone[params.index].changeQuantity > params.row.quantity ? 'ipt-error' : '',
                on: {
                  'on-blur'(event) {
                    if (isNaN(Number(event.target.value))) {
                      v.goodsListClone[params.index].changeQuantity = 1;
                      v.$nextTick(() => {
                        v.goodsListClone[params.index].changeQuantity = 0;
                      });
                    } else {
                      v.goodsListClone[params.index].changeQuantity = event.target.value;
                    }

                  }
                }
              }),
              v.goodsListClone[params.index].changeQuantity > params.row.quantity && h('p', {style: {color: '#ed4014'}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006091'))
            ]);
          }
        }
      ];
      let columns2 = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006050'),
          key: 'platformOrderTransactionId',
          minWidth: 240,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006092'),
          key: 'orderInfo',
          minWidth: 240,
          render(h, params) {
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, 'pictureUrl'),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.title),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.ymsSku)
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, params.row.variations),
                ])
              ])]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006093'),
          key: 'replaceSkuInfo',
          minWidth: 240,
          render(h, params) {
            let imgPath = null;
            let spec = '';
            let title = '';
            let sku = '';
            if (params.row._replaceGoods) {
              let skuImgPath = params.row._replaceGoods._productInfo.primaryImage;
              let spuImgPath = params.row._replaceGoods._productInfo._spuInfo.primaryImage;
              imgPath = skuImgPath ? skuImgPath : spuImgPath;
              if (params.row._replaceGoods.productGoodsSpecifications) {
                spec = params.row._replaceGoods.productGoodsSpecifications.map(i => i.name + '：' + i.value).join('、');
              }
              title = params.row._replaceGoods.name;
              sku = params.row._replaceGoods.ymsSku;
            }
            let _hasGoods = h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, title),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, sku)
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, spec),
                ])
              ])]);
            let _btn = h('Button', {
              'on': {
                'click'() {
                  v.openAddProduct({
                    index: params.index
                  });
                }
              }
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001182'));
            if (params.row._replaceGoods) {
              return _hasGoods;
            } else {
              return _btn;
            }
          }
        }
      ];
      let hideKeyList = [];
      if (!v.platformIdList.includes(val)) {
        hideKeyList = ['platformOrderTransactionId'];
      }
      v.columns1 = columns1.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
      v.columns2 = columns2.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
      v.$forceUpdate();
    }
  },
  watch: {
    'platformOrderDetails.platformId': {
      handler(val) {
        let v = this;
        v.handleColumns(val);
      },
      immediate: true,
      deep: true
    },
  },
  components: {
    addCommonProductModal,
    barcodePromptModal
  }
};
</script>

<style>
.ipt-error {
  border: 1px solid #ed4014;
}
</style>
<style scoped>
.table-close {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;
}

</style>
